import api from './axios';

/** Normalize history list after apiHandler (supports legacy + axios response shapes). */
export function parseAlertHistoryResult(result) {
  if (!result?.success) {
    return { rows: [], pagination: {}, error: result?.message || 'Failed to load alerts' };
  }
  const payload = result.data;
  if (Array.isArray(payload)) {
    return { rows: payload, pagination: {}, error: null };
  }
  if (payload && typeof payload === 'object') {
    return {
      rows: Array.isArray(payload.data) ? payload.data : [],
      pagination: payload.pagination || {},
      error: null,
    };
  }
  return { rows: [], pagination: {}, error: null };
}

export function pruneEmptyParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value != null && String(value).trim() !== '')
  );
}

// ALERT MONITORING & HISTORY (runtime Alert incidents — not visual templates)
export const alertMonitoringApi = {
  getActive: async () => {
    const res = await api.get('/admin/alerts/active');
    return res.data;
  },

  getStats: async () => {
    const res = await api.get('/admin/alerts/stats');
    return res.data;
  },

  getHistory: (params) => api.get('/admin/alerts', { params }),

  getById: (id) => api.get(`/admin/alerts/${id}`),

  getAnalytics: async (params) => {
    const res = await api.get('/admin/alerts/analytics', { params });
    return res.data;
  },

  resolveAlert: async (id, notes) => {
    const res = await api.post(`/admin/alerts/${id}/resolve`, { notes });
    return res.data;
  },

  deleteAlert: async (id, confirmation) => {
    const res = await api.delete(`/admin/alerts/${id}`, { data: { confirmation } });
    return res.data;
  },

  /** Read-only AppAlert types for history filter dropdown */
  getAppAlertTypes: async () => {
    const res = await api.get('/admin/alerts/types');
    return res.data;
  },
};

export default alertMonitoringApi;
